import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  makeStyles,
  Box,
  Typography,
  Grid,
  withStyles,
} from "@material-ui/core";

import IconCard from "../../iconCard";
import { COLORS } from "../../../../../theme/colors";
import { TextInput } from "../../../../../components/base";
import { MGMT_COMPANY } from "../../../../../services/constants";
import tenantsIcon from "../../../../../assets/images/icons/tenant.svg";
import tenantsIconSelected from "../../../../../assets/images/icons/workspace/tenants-selected.svg";
import pmcIcon from "../../../../../assets/images/icons/sub-meter-and-public.svg";
import pmcIconSelected from "../../../../../assets/images/icons/workspace/pmc-selected.svg";
import ownerIcon from "../../../../../assets/images/icons/owner.svg";
import ownerIconSelected from "../../../../../assets/images/icons/workspace/owner-selected.svg";
import otherIcon from "../../../../../assets/images/icons/workspace/other.svg";
import otherIconSelected from "../../../../../assets/images/icons/workspace/other-selected.svg";

const PurpleRadio = withStyles({
  root: {
    color: COLORS.purple,
    "&$checked": {
      color: COLORS.purple,
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const ownerIconsList = [
  {
    id: "TENANTS",
    icon: tenantsIcon,
    iconSelected: tenantsIconSelected,
    label: "Tenants Directly",
  },
  {
    id: MGMT_COMPANY,
    icon: pmcIcon,
    iconSelected: pmcIconSelected,
    label: "Mgmt. Company",
  },
  {
    id: "OTHER",
    icon: otherIcon,
    iconSelected: otherIconSelected,
    label: "Other",
  },
];

const rentModalIcons = [
  {
    id: "OWNER",
    icon: ownerIcon,
    iconSelected: ownerIconSelected,
    label: "Building Owner",
  },
  {
    id: MGMT_COMPANY,
    icon: pmcIcon,
    iconSelected: pmcIconSelected,
    label: "Mgmt. Company",
  },
  {
    id: "OTHER",
    icon: otherIcon,
    iconSelected: otherIconSelected,
    label: "Other",
  },
];

const asTitles = {
  OWNER: "owner",
  MGMT_COMPANY: "PMC",
  BOTH: "owner and PMC",
};

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: 30,
    fontWeight: 700,
    marginBottom: 30,
  },
  iconBox: {
    display: "flex",
    marginBottom: 45,
  },
  text: {
    fontSize: 18,
    fontWeight: 400,
    marginBottom: 10,
  },
  box: {
    width: 80,
    marginTop: 5,
    "& .MuiInputBase-input": {
      height: 7,
    },
  },
  italicsText: {
    fontStyle: "italic",
    color: COLORS.darks[0][50],
  },
  bottomBox: {
    paddingBottom: 20,
  },
  radioLabel: {
    fontSize: 16,
  },
}));

const PaymentModel = ({ building, onBuildingChange }) => {
  const classes = useStyles();

  const workingStatus = building.building_info?.working_status;
  const tenantPaymentModel = building.building_info?.tenant_payment_model;
  const rentModel = building.building_info?.rent_model;
  const rentPaying = building.building_info?.rent_paying;

  const onBuildingInfoChange = (key, value) => {
    onBuildingChange("building_info", {
      ...building.building_info,
      [key]: value,
    });
  };

  const onTenantPaymentModelChange = (v) => {
    if (["BACK_TO_BACK", MGMT_COMPANY].includes(v)) {
      onBuildingInfoChange("tenant_payment_model", { type: v });
    } else {
      onBuildingInfoChange("tenant_payment_model", {
        type: tenantPaymentModel?.type,
        margin: v,
      });
    }
  };

  return (
    <Box>
      <Typography className={classes.heading}>As the {asTitles[workingStatus]},</Typography>
      <Box>
        <Typography className={classes.text}>
          Who is paying the rent to the building owner?
        </Typography>
        <Box className={classes.iconBox}>
          {ownerIconsList.slice(0, workingStatus === MGMT_COMPANY ? 3 : 2).map((data) => {
            return (
              <IconCard
                key={data.id}
                id={data.id}
                src={rentPaying === data.id ? data.iconSelected : data.icon}
                selected={rentPaying === data.id}
                text={data.label}
                onClick={() => onBuildingInfoChange("rent_paying", data.id)}
              />
            );
          })}
        </Box>
      </Box>
      <Box>
        <Typography className={classes.text}>Who decide about rent model?</Typography>
        <Box className={classes.iconBox}>
          {rentModalIcons.slice(0, workingStatus === MGMT_COMPANY ? 3 : 2).map((data) => {
            return (
              <IconCard
                key={data.id}
                id={data.id}
                src={rentModel === data.id ? data.iconSelected : data.icon}
                selected={rentModel === data.id}
                text={data.label}
                onClick={() => onBuildingInfoChange("rent_model", data.id)}
              />
            );
          })}
        </Box>
      </Box>
      <Box className={classes.bottomBox}>
        <Typography className={classes.text}>What is the payment model of the tenants?</Typography>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="tenant"
            name="tenant"
            value={tenantPaymentModel?.type}
            onChange={(e) => onTenantPaymentModelChange(e.target.value)}
          >
            <FormControlLabel
              value="BACK_TO_BACK"
              control={<PurpleRadio />}
              classes={{ label: classes.radioLabel }}
              label="Full “back to back” - No costs of rent of management company"
            />
            <Grid container alignItems="center">
              <FormControlLabel
                value={MGMT_COMPANY}
                control={<PurpleRadio />}
                classes={{ label: classes.radioLabel }}
                label="Management company to decide. Their margin is"
              />
              <TextInput
                type="number"
                value={tenantPaymentModel?.margin}
                onChange={onTenantPaymentModelChange}
                style={{ background: COLORS.white }}
                containerStyle={classes.box}
              />
              &nbsp;
              <Typography>{"% "}</Typography>
              &nbsp;
              <Typography className={classes.italicsText}>{" (Optional)"}</Typography>
            </Grid>
          </RadioGroup>
        </FormControl>
      </Box>
    </Box>
  );
};

export default PaymentModel;
